// const setAllFundsValues = payload => ({
//   type: "SET_All_FUNDS_VALUES",
//   payload
// });

const setEmployerDetails = payload => ({
  type: "SET_EMPLOYER_DETAILS",
  payload
});

export default {
  setEmployerDetails
};
